import React, { useContext } from "react";
import { themeContext } from "../../lib";

interface IHistoryIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const HistoryIcon: React.FC<IHistoryIconProps> = ({ sizeX = 17, sizeY = 16 }) => {
    const [theme] = useContext(themeContext);

    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1668 14.6668H12.5002C12.8538 14.6668 13.1929 14.5264 13.443 14.2763C13.693 14.0263 13.8335 13.6871 13.8335 13.3335V4.66683L10.5002 1.3335H4.50016C4.14654 1.3335 3.8074 1.47397 3.55735 1.72402C3.30731 1.97407 3.16683 2.31321 3.16683 2.66683V4.66683M9.8335 1.3335V4.00016C9.8335 4.35378 9.97397 4.69292 10.224 4.94297C10.4741 5.19302 10.8132 5.3335 11.1668 5.3335H13.8335M6.8335 11.6668L5.8335 10.8335V9.3335M9.8335 10.6668C9.8335 12.876 8.04264 14.6668 5.8335 14.6668C3.62436 14.6668 1.8335 12.876 1.8335 10.6668C1.8335 8.45769 3.62436 6.66683 5.8335 6.66683C8.04264 6.66683 9.8335 8.45769 9.8335 10.6668Z"
                stroke={theme === "dark" ? "white" : "black"}  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
